import { Link } from "react-router-dom";
import { useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "../lib/cart";
import { resolveImg } from "../lib/api";

export const CartDrawer = () => {
  const { items, setQty, remove, count, open, setOpen } = useCart();
  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] bg-black/50" onClick={() => setOpen(false)} data-testid="cart-overlay">
          <motion.aside initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "tween", duration: 0.25 }}
            className="absolute right-0 top-0 h-full w-full max-w-md bg-white flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="cart-drawer">
            <div className="flex items-center justify-between p-5 border-b border-black/10">
              <h3 className="font-display font-bold text-lg flex items-center gap-2"><ShoppingBag size={18} className="text-[#E63946]" /> Your Cart ({count})</h3>
              <button onClick={() => setOpen(false)} data-testid="cart-close-btn" className="grid place-items-center w-9 h-9 rounded-full hover:bg-black/5"><X size={18} /></button>
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {items.length === 0 && <p className="text-black/40 text-center py-16">Your cart is empty.</p>}
              {items.map((i) => (
                <div key={`${i.id}${i.size}${i.color}`} className="flex gap-3 items-center" data-testid="cart-item">
                  <div className="w-16 h-16 rounded-md bg-[#F4F4F5] overflow-hidden shrink-0">
                    {i.image && <img src={resolveImg(i.image)} alt="" className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-sm truncate">{i.name}</p>
                    <p className="text-xs text-black/45">{[i.size, i.color].filter(Boolean).join(" / ")}</p>
                    <p className="text-sm font-bold text-[#E63946]">${Number(i.price).toFixed(2)}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <button onClick={() => setQty(i, i.qty - 1)} className="w-7 h-7 rounded-full border border-black/15 text-sm">−</button>
                    <span className="w-5 text-center text-sm">{i.qty}</span>
                    <button onClick={() => setQty(i, i.qty + 1)} className="w-7 h-7 rounded-full border border-black/15 text-sm">+</button>
                  </div>
                  <button onClick={() => remove(i)} data-testid="cart-remove-btn" className="grid place-items-center w-8 h-8 rounded-full hover:bg-[#E63946]/10 text-[#E63946]"><Trash2 size={15} /></button>
                </div>
              ))}
            </div>
            {items.length > 0 && (
              <div className="p-5 border-t border-black/10 space-y-3">
                <div className="flex justify-between text-sm"><span className="text-black/60">Subtotal</span><span className="font-bold">${subtotal.toFixed(2)}</span></div>
                <p className="text-xs text-black/40">Any discounts, service fee, shipping & tax are shown at checkout before you pay.</p>
                <Link to="/checkout" onClick={() => setOpen(false)} data-testid="cart-checkout-btn"
                  className="block text-center rounded-full bg-[#E63946] text-white py-3.5 font-medium hover:bg-[#BA1B25] transition-colors">Checkout</Link>
              </div>
            )}
          </motion.aside>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
